module.exports = __webpack_public_path__ + "img/navigation_favorites.b9c7f6e8.png";